import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { ToggleButton, Box, Typography } from '@mui/material';
import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    padding: theme.spacing(1),
    height: '30px',
    '&.Mui-selected': {
        backgroundColor: 'var(--mui-palette-primary-orange)',
        color: 'var(--mui-palette-common-white)',
        '&:hover': {
            backgroundColor: 'var(--mui-palette-primary-orange)',
        },
    },
}));


export const QuizPOC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    return <>
        <div>
            <div className='course'>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <Typography
                        align="left"
                        variant="h1"
                        color="primary.blue"
                        sx={{
                            margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.5',
                            fontSize: '1.8rem',
                        }}>Quiz POC</Typography>
                </Box>
            </div>

        </div>
    </>
}
const styles = {
    toggleButtonContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    create: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '0',
        marginBottom: '0',
        marginLeft: '5px',
    },
    courses: {
        marginTop: '2rem'
    },
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    gridContainer: {
        mt: 2,
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
    },
    hiddenInput: {
        display: 'none',
    }
};
